module.exports = __webpack_public_path__ + "img/plus.57ee914f.svg";